import React, { useContext, useState, useEffect } from 'react';
import { Dropdown, Divider } from '@fluentui/react-northstar';
import AppCSS from '../App.module.css';
import { inputItems } from './ticketHelper';
import { AppStateContext, useSetState } from '../AppState';
import { getCachedFeature } from '../shared/cache/FeatureCache';
import { LICENSE_FEATURE } from '../shared/utils/constants';
import { useTranslation } from 'react-i18next';

export const BoardMenu = () => {
  const setState = useSetState();
  const state = useContext(AppStateContext);
  // Seed from the persisted board filter so the trigger reflects the current group-by after the
  // toolbar remounts (e.g. returning from editing a ticket), not just the default "Status".
  const [laneFilter, setLaneFilter] = useState(state.boardFilter ?? 0);
  const [groupByItems, setGroupByItems] = useState(getInputItemValues(inputItems));
  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      const enabledMultiDepartment = await getCachedFeature(LICENSE_FEATURE.MultiDepartment);
      if(!enabledMultiDepartment){
        const clonedInputItems = {...inputItems};
        delete clonedInputItems.team;
        setGroupByItems(getInputItemValues(clonedInputItems));
      }
    })();
  }, []);

  // Keep the trigger label in sync if the board filter changes elsewhere.
  useEffect(() => {
    setLaneFilter(state.boardFilter ?? 0);
  }, [state.boardFilter]);

  return (
    <>
      <Divider
        vertical
        color="gray"
        style={{ height: '40px', marginTop: '4px' }}
      />
      <Dropdown
        items={groupByItems}
        triggerButton={<span>{t('ticket.ticket-board.group-by-filter.title', {status: groupByItems[laneFilter]})}</span>}
        fluid
        className={`${AppCSS.dropdownItem} h-12 dropdown-btn`}
        defaultValue={groupByItems[state.boardFilter ?? 0]}
        onChange={(event, props) => {
          var active =
            typeof props.highlightedIndex == 'undefined'
              ? 0
              : props.highlightedIndex;
          setLaneFilter(active);
          setState(s => {
            return {
              ...s,
              boardFilter: props.highlightedIndex
            };
          });
        }}
      />
      <Divider
        vertical
        color="gray"
        style={{ height: '40px', marginTop: '4px' }}
      />
    </>
  );
};

export function getInputItemValues(inputItems: IInputItems): string[] {
  return Object.values(inputItems)
}